import { apiDelete, apiGet, apiPatch, apiPost } from "./client";
import type {
  KbDocumentCreateRequest,
  KbDocumentOut,
  KbDocumentPatchRequest,
  KbList,
  KbPreviewRequest,
  KbPreviewResponse,
} from "@/types/knowledge";

/** GET /api/kb não recebe filtros — devolve o inventário completo das bases
 *  de conhecimento (todos os eventos). Filtragem por evento/base é client-side. */
export function getKb(): Promise<KbList> {
  return apiGet<KbList>("/api/kb");
}

export function createKbDocument(body: KbDocumentCreateRequest): Promise<KbDocumentOut> {
  return apiPost<KbDocumentOut>("/api/kb/documents", body);
}

export function patchKbDocument(
  docId: number | string,
  body: KbDocumentPatchRequest,
): Promise<KbDocumentOut> {
  return apiPatch<KbDocumentOut>(`/api/kb/documents/${docId}`, body);
}

export function deleteKbDocument(docId: number | string) {
  return apiDelete(`/api/kb/documents/${docId}`);
}

export function previewKb(body: KbPreviewRequest): Promise<KbPreviewResponse> {
  return apiPost<KbPreviewResponse>("/api/kb/preview", body);
}
